import React, { useEffect, useState } from 'react';
import './../../css/CoronaView.css';
import axios from "axios";
import { Col, Row, Button, Form, FormGroup, Label, Input, CustomInput, FormText } from 'reactstrap';
import $ from 'jquery';
import Swal from 'sweetalert2'

const CoronaView = (props) => {
  const [cncode, setCncode] = useState("");
  useEffect(() => {
      const cnTempcode = props.match.params.cncode
      console.log("cncode : "+cnTempcode)
      setCncode(cnTempcode)
      if(cnTempcode !== 'register'){
        callCoronanInfoApi(cnTempcode)
      }
  }, []);

  const callCoronanInfoApi = (cncode) => {
    axios.post('/api/infection?type=list', {
        is_Num: cncode,
    })
    .then( response => {
        try {
            var data = response.data.result[0]
            
            $('#is_Comment').val(data.comment);
            $('#is_Lat').val(data.lat);
            $('#is_Lng').val(data.lng);
            $('#is_Date').val(data.date);
            $('#is_Finish').val(data.finish);
            $('#is_Finish_date').val(data.finish_date);
            $('#is_Gender').val(data.gender);
            $('#is_Birth').val(data.birth);
            $('#is_Nation').val(data.nation);
            $('#is_Contact').val(data.contact);
            $('#is_Via_path').val(data.via_path);

            $('#imgPreview').remove()
            $('#upload_img').prepend('<img id="imgPreview" src="'+data.hospi_img+'"/>')

        } catch (error) {
            alert('작업중 오류가 발생하였습니다.'+error)
        }
    })
    .catch( error => {alert('작업중 오류가 발생하였습니다.');return false;} );
  }

  const submitClick = async(type, e) => {
    const is_Comment = $('#is_Comment').val();
    const is_Lat = $('#is_Lat').val();
    const is_Lng = $('#is_Lng').val();
    const is_Date = $('#is_Date').val();
    const is_Finish = $('#is_Finish').val();
    const is_Finish_date = $('#is_Finish_date').val();
    const is_Gender = $('#is_Gender').val();
    const is_Birth = $('#is_Birth').val();
    const is_Nation = $('#is_Nation').val();
    const is_Contact = $('#is_Contact').val();
    const is_Hospi_img = $('#is_Hospi_img').val();
    const is_Via_path = $('#is_Via_path').val();

    const fnValidate = (e) => {
        if(is_Comment === '') {
            $('#is_Comment').addClass('border_validate_err');
            alert('격리 시설 정보를 다시 확인해주세요.')
            return false;
        }
        $('#is_Comment').removeClass('border_validate_err');

        if(is_Lat === '') {
            $('#is_Lat').addClass('border_validate_err');
            alert('위도 좌표를 다시 확인해주세요.')
            return false;
        }
        $('#is_Lat').removeClass('border_validate_err');

        if(is_Lng === '') {
            $('#is_Lng').addClass('border_validate_err');
            alert('경도 좌표를 다시 확인해주세요.')
            return false;
        }
        $('#is_Lng').removeClass('border_validate_err');

        if(is_Date === '') {
            $('#is_Date').addClass('border_validate_err');
            alert('확진 날짜를 다시 확인해주세요.')
            return false;
        }
        $('#is_Date').removeClass('border_validate_err');

        if(is_Finish === '') {
            $('#is_Finish').addClass('border_validate_err');
            alert('완치 여부를 다시 확인해주세요.')
            return false;
        }
        $('#is_Finish').removeClass('border_validate_err');
        
        if(is_Finish_date === '') {
            $('#is_Finish_date').addClass('border_validate_err');
            alert('완치 날짜를 다시 확인해주세요.')
            return false;
        }
        $('#is_Finish_date').removeClass('border_validate_err');

        if(is_Gender === '') {
            $('#is_Gender').addClass('border_validate_err');
            alert('성별을 다시 확인해주세요.')
            return false;
        }
        $('#is_Gender').removeClass('border_validate_err');

        if(is_Birth === '') {
            $('#is_Birth').addClass('border_validate_err');
            alert('생년을 다시 확인해주세요.')
            return false;
        }
        $('#is_Birth').removeClass('border_validate_err');

        if(is_Nation === '') {
            $('#is_Nation').addClass('border_validate_err');
            alert('국적을 다시 확인해주세요.')
            return false;
        }
        $('#is_Nation').removeClass('border_validate_err');

        if(is_Contact === '') {
            $('#is_Contact').addClass('border_validate_err');
            alert('접촉자 수를 다시 확인해주세요.')
            return false;
        }
        $('#is_Contact').removeClass('border_validate_err');
        
        if((is_Hospi_img === '' || is_Hospi_img === undefined) && type !== "modify") {
            $('#is_Hospi_img').addClass('border_validate_err');
            alert('병원 이미지를 다시 확인해주세요.')
            return false;
        }
        $('#is_Hospi_img').removeClass('border_validate_err');

        if(is_Via_path === '') {
            $('#is_Via_path').addClass('border_validate_err');
            alert('이동 경로를 다시 확인해주세요.')
            return false;
        }
        $('#is_Via_path').removeClass('border_validate_err');

        return true;
    }

    if(fnValidate()){
        var jsonstr = $("form[id='frm']").serialize();
        console.log("1. c : "+jsonstr)
        jsonstr = decodeURIComponent(jsonstr);
        var Json_form = JSON.stringify(jsonstr).replace(/\"/gi,'') 
        //replace("/",'') : 정규식 없는 replace함수
        Json_form = "{\"" +Json_form.replace(/\&/g,'\",\"').replace(/=/gi,'\":"')+"\"}";
        console.log("2. Json_form : "+Json_form)
    
        try {
            const response = await fetch('/api/infection?type='+type, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: Json_form,
            });
            const body = await response.text();
            if(body == "succ"){
                if(type == 'save'){
                    sweetalertSucc('확진자 격리 정보 등록이 완료되었습니다.', false)
                }else if(type == "modify"){
                    sweetalertSucc('확진자 격리 정보 수정이 완료되었습니다.', false)
                }
                setTimeout(function() {
                    props.history.push('/CoronaList');
                    }.bind(this),1500
                );
            }else{
                alert('작업중 오류가 발생하였습니다.')
            }  
        } catch (error) {
            alert('작업중 오류가 발생하였습니다.')
        }
    }
  };

  const sweetalertSucc = (title, showConfirmButton) => {
    Swal.fire({
        position: 'bottom-end',
        icon: 'success',
        title: title,
        showConfirmButton: showConfirmButton,
        timer: 1000
    })
  }   

  const handleFileInput = (e) => {
    var file = e.target.files[0]
    setTimeout(function() {
        handlePostImage(file)
    }.bind(this),1000
    );
  }

  const handlePostImage = (imgfile) => {
    const formData = new FormData();
    formData.append('file', imgfile);
    return axios.post("/api/upload?type=uploads/image/", formData).then(res => {
        var filename = res.data.filename
        $('#is_Hospi_img').remove()
        $('#imgPreview').remove()
        $('#upload_img').prepend('<img id="imgPreview" src="/image/'+filename+'"/>')
        $('#upload_img').prepend('<input id="is_Hospi_img" type="hidden"'
        +'name="is_Hospi_img" value="/image/'+filename+'"/>')
    }).catch(error => {
        alert('작업중 오류가 발생하였습니다.'+error)            
    })
  }

  return (
    <section class="sub_wrap">
      <article class="s_cnt mp_pro_li ct1">
          <div class="li_top">
              <h2 class="s_tit1">확진자 격리 정보 등록/수정</h2>
          </div>
          <div class="bo_w re1_wrap re1_wrap_writer">
          <Form id="frm">
            <input id="is_Cncode" type="hidden" name="is_Cncode" value={cncode} />
            <Row form>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Comment">격리 시설 정보</Label>
                    <Input type="text" name="is_Comment" id="is_Comment" placeholder="병원명 입력" />
                </FormGroup>
                </Col>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Lat">위도 좌표</Label>
                    <Input type="text" name="is_Lat" id="is_Lat" placeholder="숫자와 소수점" />
                </FormGroup>
                </Col>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Lat">경도 좌표</Label>
                    <Input type="text" name="is_Lng" id="is_Lng" placeholder="숫자와 소수점" />
                </FormGroup>
                </Col>
            </Row>
            <Row form>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Date">확진 날짜</Label>
                    <Input
                    type="date"
                    name="is_Date"
                    id="is_Date"
                    placeholder="date placeholder"
                    />
                </FormGroup>
                </Col>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Finish">완치 여부</Label>
                    <CustomInput type="select" id="is_Finish" name="is_Finish">
                        <option value="">Select</option>
                        <option>치료중</option>
                        <option>완치</option>
                    </CustomInput>
                </FormGroup>
                </Col>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Finish_date">완치 날짜</Label>
                    <Input
                    type="date"
                    name="is_Finish_date"
                    id="is_Finish_date"
                    placeholder="date placeholder"
                    />
                </FormGroup>
                </Col>
            </Row>
            <Row form>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Gender">성별</Label>
                    <CustomInput type="select" id="is_Gender" name="is_Gender">
                        <option value="">Select</option>
                        <option>남자</option>
                        <option>여자</option>
                    </CustomInput>
                </FormGroup>
                </Col>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Birth">생년</Label>
                    <Input
                    type="date"
                    name="is_Birth"
                    id="is_Birth"
                    placeholder="date placeholder"
                    />
                </FormGroup>
                </Col>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Nation">국적</Label>
                    <Input type="text" name="is_Nation" id="is_Nation" placeholder="예) 한국" />
                </FormGroup>
                </Col>
                <Col md={2}>
                <FormGroup>
                    <Label for="is_Contact">접촉자 수</Label>
                    <Input type="text" name="is_Contact" id="is_Contact" placeholder="숫자만 입력" />
                </FormGroup>
                </Col>
            </Row>
            <FormGroup>
                <Label for="is_Via_path">이동경로</Label>
                <Input type="textarea" name="is_Via_path" id="is_Via_path" />
            </FormGroup>
            <FormGroup>
                <Label for="is_ImgTemp">병원 이미지</Label>
                <Input type="file" name="is_ImgTemp" id="is_ImgTemp" onChange={e => handleFileInput(e)} />
                <FormText color="muted">
                </FormText>
                <div id="upload_img">
                </div>
            </FormGroup>
            {cncode =='register' ?
                <Button onClick={e => submitClick('save', e)}>저장</Button>
                :
                <Button onClick={e => submitClick('modify', e)}>수정</Button>
            }
          </Form>
          </div> 
        </article>
    </section>
  );
};

export default CoronaView;